import React from 'react';
import { string, arrayOf } from 'prop-types';

const Header = (props) => {
    const { title, paragraphs } = props;

    // Filter out empty values
    const copy = paragraphs.filter(Boolean);

    return (
        <div className='header-container'>
            <h1>{title}</h1>
            {copy.map((paragraph, i) => (
                <p className="message" key={`header_paragraph_${i}`} dangerouslySetInnerHTML={{__html: paragraph}} />
            ))}
        </div>
    );
};

Header.propTypes = {
    title: string.isRequired,
    paragraphs: arrayOf(string),
};

Header.defaultProps = {
    paragraphs: [],
};

export default Header;
